module.exports = __webpack_public_path__ + "img/home-53-hero_9x16_jp_poster.bb17c92.jpg";